'use client'

import { clientPage } from './_lib/clientPage'

// App Router 404. NotFoundRoutePage renders its own chrome; loaded client-only.
const NotFoundPage = clientPage(() =>
  import('@/components/views/NotFoundRoutePage').then((m) => ({
    default: m.NotFoundRoutePage,
  }))
)

export default function NotFound() {
  return <NotFoundPage />
}
